module.exports = __webpack_public_path__ + "img/Fondo_Titulo.3576b4b6.svg";